import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { resourceDetailsQueryKeys } from './resourceDetailsQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const sizes = [
  32,
  64,
  128
];
const isValidImage = async (url, requestedSize) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      if (requestedSize && img.naturalWidth !== requestedSize || !sizes.find((item) => item === img.naturalWidth)) {
        resolve(false);
      } else {
        resolve(true);
      }
    };
    img.onerror = () => resolve(false);
    img.src = url;
  });
};
const faviconKitBase = `https://grumpy-plum-snail.faviconkit.com`;
const getFaviconKitImage = async (url, size) => {
  try {
    const urlObject = new URL(url);
    const base = `${faviconKitBase}/${urlObject.hostname}/${size}`;
    const isValid = await isValidImage(base, size);
    return isValid ? base : null;
  } catch {
    return null;
  }
};
const getGoogleFavicon = async (url, size) => {
  try {
    const urlObject = new URL(url);
    const base = `https://www.google.com/s2/favicons?domain=${urlObject.hostname}&sz=${size}`;
    const isValid = await isValidImage(base, size);
    return isValid ? base : null;
  } catch {
    return null;
  }
};
const getDuckDuckGoFavicon = async (url) => {
  try {
    const urlObject = new URL(url);
    const base = `https://icons.duckduckgo.com/ip2/${urlObject.hostname}.ico`;
    const isValid = await isValidImage(base);
    return isValid ? base : null;
  } catch {
    return null;
  }
};
const getWoodyFavicon = async (url, client) => {
  try {
    const res = await client.v2("/v2/link", {
      query: {
        url
      }
    });
    const faviconUrl = res.favicon?.url;
    return faviconUrl && await isValidImage(faviconUrl) ? faviconUrl : null;
  } catch {
    return null;
  }
};
const useQueryPageFavicon = (variables, queryOptions) => {
  const { client } = useWoody();
  const size = variables.size || 32;
  const url = variables.url;
  const query = useQuery({
    queryKey: resourceDetailsQueryKeys.favicon(url, size),
    queryFn: async (params) => {
      const safeUrl = params.queryKey[1];
      const safeSize = params.queryKey[2];
      return await getFaviconKitImage(safeUrl, safeSize) || await getGoogleFavicon(safeUrl, safeSize) || await getWoodyFavicon(safeUrl, client) || await getDuckDuckGoFavicon(safeUrl);
    },
    placeholderData: keepPreviousData,
    staleTime: 1e3 * 60 * 60 * 24,
    ...queryOptions,
    enabled: isQueryEnabled([
      !!url,
      queryOptions?.enabled
    ])
  });
  return query;
};

export { useQueryPageFavicon };
//# sourceMappingURL=useQueryPageFavicon.js.map
